import classesCss from './Dropdown.module.css'
import {useRef} from 'react';

const Dropdown = ({sub, items, menuHeight, headerHeight, fontSize}) => {
    const menu = useRef(null);
    const header = useRef(null);

    const hideDrop = () => {
        menu.current.style.transform = "scaleY(0)";
        menu.current.style.backgroundColor = "inherit";
        setTimeout(() => {
            menu.current.style.display = "none";
        }, 200);
        header.current.style.backgroundColor = "inherit";
    };

    const showDrop = () => {
        menu.current.style.display = "flex";
        setTimeout(() => {
            menu.current.style.transform = "scaleY(1)";
            menu.current.style.backgroundColor = "#F7912F";
        }, 50);
        header.current.style.backgroundColor = "#F7912F";
    };

    return (
        <div className={classesCss.dropdown} onMouseLeave={hideDrop}>
            <a href={sub.url} ref={header}
               className={classesCss.dropdown__sub}
               onMouseEnter={showDrop}
               style={{
                   padding: headerHeight,
                   fontSize,
                }}>
                {sub.text.toUpperCase()}
            </a>
            <div className={classesCss.dropdown__menu} ref={menu} style={{
                marginTop: menuHeight
            }}>
                {
                    items.map(({url, text}, index) =>
                        <a href={url} className={classesCss.dropdown__menu__item} key={index}>
                            {text}
                        </a>)
                }
            </div>
        </div>
    );
};

export default Dropdown;